import {
    ADDON_SERVICES_ERROR_ACTION_TYPE,
    ADDON_SERVICES_FETCH_ACTION_TYPE,
    ADDON_SERVICES_FETCH_SUCCESS_ACTION_TYPE,
    AddonServicesAction
} from 'actions/addonServices/AddonServicesActionsTypes';
import { convertToAddonService } from 'actions/addonServices/AddonServicesConverter';
import { AddonServiceDto } from 'actions/addonServices/AddonServicesDtos';
import { ApiPublicClient } from 'api/ApiClient';
import { AxiosResponse } from 'axios';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store';
import { RootAction } from 'types/Actions';

const resourceUrl = 'addon_service_lookup';

const errorHandler = (error: unknown): AddonServicesAction => {
    console.error(error);

    return {
        type: ADDON_SERVICES_ERROR_ACTION_TYPE
    };
};

export const fetchAddonServicesThunk = (
    marketplaceId: number
): ThunkAction<Promise<void>, RootState, null, RootAction> => {
    return async dispatch => {
        dispatch(fetchStart());

        try {
            const response: AxiosResponse<Array<AddonServiceDto>> = await ApiPublicClient.get(
                resourceUrl,
                {
                    params: {
                        marketplace_id: marketplaceId
                    }
                }
            );
            dispatch(fetchSucces(response.data));
        } catch (error) {
            dispatch(errorHandler(error));
        }
    };
};

const fetchStart = (): AddonServicesAction => {
    return {
        type: ADDON_SERVICES_FETCH_ACTION_TYPE
    };
};

export const fetchSucces = (addonsDto: Array<AddonServiceDto>): AddonServicesAction => {
    return {
        type: ADDON_SERVICES_FETCH_SUCCESS_ACTION_TYPE,
        payload: {
            addonServices: addonsDto.map(service => convertToAddonService(service))
        }
    };
};
